import axios, { AxiosError } from "axios";

// API URL — preferencia: VITE_API_URL (.env) > padrao = API do Cabal Next (host 108; a do Liberty era o padrao antigo)
export const API_URL = import.meta.env.VITE_API_URL
  || 'https://api.cabalnext.com/api';
const accountUrl = `${API_URL}/Account`;

/* =======================
   Types
   ======================= */


export interface RegisterRequest {
  username: string;
  password: string;
  name: string;
  cellphone: string;
  code?: string | null;
  ReferCode?: string | null;   // indicacao (?ref=) capturada no localStorage
}

export interface RegisterResponse {
  status: string;
  message: string;
  retryAfterSeconds?: number;
  remaining?: number;
}

export interface  VerifyPayload  {
  Username: string;
  Password: string;
  Cellphone?: string | null;
  Code?: string | null;
};


export const apiLoginVerify = async (
 body: VerifyPayload
): Promise<any> => {
  try {
    const res = await axios.post<any>(
      `${accountUrl}/loginVerify`,
      body
    );

    return res.data;
  } catch (error) {
    const err = error as AxiosError<any>;

    if (err.response?.data) {
      throw err.response.data;
    }

    throw 400;
  }
};


/* =======================
   Request
   ======================= */

export interface ForgotPasswordRequest {
  contact: string;       // ID, e-mail ou celular (E164)
  code?: string | null;
  newPassword?: string | null;
}

export const forgotPassword = async (
  body: ForgotPasswordRequest
): Promise<any> => {
  try {
    const res = await axios.post<any>(
      `${accountUrl}/forgotPassword`,
      body
    );
    return res.data;
  } catch (error) {
    const err = error as AxiosError<any>;
    if (err.response?.data) throw err.response.data;
    throw 400;
  }
};

export const createAccount = async (
  body: RegisterRequest
): Promise<any> => {
  try {
    const res = await axios.post<any>(
      `${accountUrl}/register`,
      body
    );

    return res.data;
  } catch (error) {
    const err = error as AxiosError<any>;

    if (err.response?.data) {
      throw err.response.data;
    }

    throw 400;
  }
};

/* =======================
   Register por Email -- 2 passos por CODIGO (sem Code: manda o codigo; com Code: cria a conta)
   ======================= */

export interface RegisterEmailRequest {
  Username: string;
  Password: string;
  Email: string;
  Name: string;
  ReferCode?: string | null;
  Captcha?: string | null;
  Code?: string | null;          // passo 2: codigo que chegou no e-mail
}

export const registerEmail = async (body: RegisterEmailRequest): Promise<any> => {
  try {
    const res = await axios.post<any>(`${accountUrl}/registerEmail`, body);
    return res.data;
  } catch (error) {
    const err = error as AxiosError<any>;
    if (err.response?.data) throw err.response.data;
    throw 400;
  }
};

/* =======================
   Verify email key (GET /verify/{key})
   ======================= */

export const verifyEmailKey = async (key: string): Promise<any> => {
  try {
    const res = await axios.get<any>(`${accountUrl}/verify/${encodeURIComponent(key)}`);
    return res.data;
  } catch (error) {
    const err = error as AxiosError<any>;
    if (err.response?.data) throw err.response.data;
    throw 400;
  }
};

/* =======================
   Google login (ID token via GSI)
   ======================= */

export interface GoogleLoginRequest {
  IdToken: string;
  // Username + Password preenchidos apenas no 2o submit (apos NEEDS_SETUP)
  Username?: string | null;
  Password?: string | null;
  ReferCode?: string | null;   // indicacao (?ref=) capturada no localStorage
}

export const googleLogin = async (body: GoogleLoginRequest): Promise<any> => {
  try {
    const res = await axios.post<any>(`${accountUrl}/googleLogin`, body);
    return res.data;
  } catch (error) {
    const err = error as AxiosError<any>;
    if (err.response?.data) throw err.response.data;
    throw 400;
  }
};
